import React from "react";

const UserInfoSection = ({ dataUser }) => (
  <>
    <div className="section-label">User info. (ข้อมูลผู้ยืนคำขอ)</div>
    <div className="form-card">
      {!dataUser ? (
        <div>Loading...</div>
      ) : (
        <div className="user-info-grid">
          <div className="user-field">
            <label>ชื่อผู้ใช้ (Username)</label>
            <div className="value-box">{dataUser.email}</div>
          </div>
          <div className="user-row">
            <div className="user-field">
              <label>ชื่อ (Name)</label>
              <div className="value-box">{dataUser.name}</div>
            </div>
            <div className="user-field">
              <label>สกุล (Surname)</label>
              <div className="value-box">{dataUser.surname}</div>
            </div>
          </div>
          <div className="user-field">
            <label>เบอร์โทรศัพท์ที่ติดต่อได้ (Contact number)</label>
            <div className="value-box">{dataUser.tel}</div>
          </div>
        </div>
      )}
    </div>
  </>
);

export default UserInfoSection;